import { createSvgIcon } from '@mui/material/utils'

const DeleteTrash = createSvgIcon(
  <>
    <path
      d="M63.9501 74.07L65.9501 48.17H8.36011L10.3601 74.07"
      stroke="#204ECF"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M41.11 74.07V61.57C41.11 59.39 39.34 57.62 37.16 57.62C34.98 57.62 33.21 59.39 33.21 61.57V74.07"
      stroke="#204ECF"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M25.2999 74.07V61.57C25.2999 59.39 23.5299 57.62 21.3499 57.62C19.1699 57.62 17.3999 59.39 17.3999 61.57V74.07"
      stroke="#204ECF"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M56.9298 74.07V61.57C56.9298 59.39 55.1598 57.62 52.9798 57.62C50.7998 57.62 49.0298 59.39 49.0298 61.57V74.07"
      stroke="#204ECF"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M37.7302 44.42C38.3402 41.5 41.7102 40.91 41.7102 40.91C41.7102 40.91 40.6602 38.55 42.8602 36.4C45.0602 34.24 48.3102 35.57 48.3102 35.57C48.3102 35.57 48.5902 32.6 51.3202 32.06C54.0502 31.52 55.9002 34.29 55.9002 34.29C55.9002 34.29 58.9602 31.96 61.5802 34.28C64.1902 36.59 62.8102 39.27 62.2202 40.25C62.2202 40.25 64.2202 42.48 63.7102 44.59C63.1902 46.73 60.8702 47.84 60.8702 47.84C60.8702 47.84 60.9702 47.99 61.0902 48.26"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M57.9502 39.15C56.0602 42.47 53.4302 45.6 50.6902 48.36"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M53.81 39.26C52.77 41.61 55.04 42.97 55.04 42.97"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M48.8802 42.36C47.5502 44.94 50.6802 47.81 50.6802 47.81"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M44.07 45.69C43.7 46.56 43.74 47.48 43.97 48.36"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M47.4601 35.23C47.4601 35.23 45.8701 30.96 42.6501 32.27C40.7501 33.04 40.8501 35.6 40.8501 35.6C40.8501 35.6 38.9001 33.97 37.1101 35.48C35.3201 37 36.8701 38.83 36.8701 38.83C36.8701 38.83 33.8501 38.18 33.0801 40.31C32.3101 42.44 34.3501 43.74 34.3501 43.74C34.3501 43.74 31.3301 45.49 32.7801 48.18"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M55.04 42.97C57.67 44.13 59.02 43.02 59.21 42.87"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M10.79 48.16C13.42 43.69 20.61 31.86 21.74 30.12C23.5 27.4 27.14 31 27.14 31C27.14 31 31.17 34.16 28.7 36.24C27.56 37.2 24.15 39.87 20.81 42.48"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M33.5601 25.67C33.5601 25.67 29.5601 27.43 27.0801 30.88C27.0801 30.88 28.7801 27.73 27.3601 25.67"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M33.2199 30.37C33.2199 30.37 30.7099 28.66 27.4299 31.19"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M24.05 34.86C24.05 34.86 22.68 32.82 20.55 32.2"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M21.92 37.43C21.92 37.43 20.76 35.71 18.97 35.19"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M19.11 40.11C19.11 40.11 18.27 38.66 16.74 38.38"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M16.6299 48.02C16.6299 44.89 19.1599 42.36 22.2899 42.36C25.4199 42.36 27.9499 44.89 27.9499 48.02"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M24.71 42.87C24.71 39.74 27.24 37.21 30.37 37.21C31.93 37.21 33.35 37.84 34.37 38.87"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M11.9999 45.69L7.8299 32.15L10.0099 28.22L0.649902 2.02L5.0299 0.630005L13.1499 27.22L17.1999 29.17L19.2199 34.13"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path d="M16.7398 38.37L14.8398 32.56" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M14.36 41.63L11.71 33.55" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M37.3301 21.53C37.3301 18.92 40.0701 18.92 40.0701 16.3C40.0701 13.69 37.3301 13.69 37.3301 11.08C37.3301 8.47 40.0701 8.47 40.0701 5.85C40.0701 3.24 37.3301 3.24 37.3301 0.619995"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M48.96 12.56C47.4 14.66 49.6 16.29 48.04 18.39C46.48 20.48 44.28 18.85 42.72 20.94C41.16 23.04 43.36 24.67 41.79 26.77"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M68.84 48.02H5.47998V51.5H68.84V48.02Z"
      fill="white"
      stroke="#204ECF"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </>,
  'DeleteTrash'
)

export default DeleteTrash
